/**
 * SectionRow — reusable row primitive for Me overview + Settings overview.
 * Icon · Label (+ optional subtitle) · optional count badge · chevron.
 */

import type { ReactNode } from 'react';
import styles from './SectionRow.module.css';

export interface SectionRowProps {
  label: string;
  onClick: () => void;
  icon?: ReactNode;
  subtitle?: string;
  badge?: string | number;
  'data-testid'?: string;
}

export function SectionRow({
  label,
  onClick,
  icon,
  subtitle,
  badge,
  'data-testid': testId,
}: SectionRowProps): JSX.Element {
  return (
    <button
      type="button"
      className={styles.row}
      onClick={onClick}
      data-testid={testId}
    >
      {icon !== undefined && (
        <span className={styles.icon} aria-hidden="true">
          {icon}
        </span>
      )}
      <span className={styles.labelGroup}>
        <span className={styles.label}>{label}</span>
        {subtitle && <span className={styles.subtitle}>{subtitle}</span>}
      </span>
      {badge !== undefined && badge !== '' && (
        <span className={styles.badge} data-testid="section-row-badge">
          {badge}
        </span>
      )}
      <span className={styles.chevron} aria-hidden="true">
        ›
      </span>
    </button>
  );
}
